module.exports = __webpack_public_path__ + "img/pranavi.14225868.webp";